import { PatientGetCollectionByTrialCode, PatientCollectionResponse } from '@/api/dtos';
import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';

const getData = (response?: SWRResponse<PatientCollectionResponse, PatientCollectionResponse>) => response?.data?.data;
const getError = (response?: SWRResponse<PatientCollectionResponse, PatientCollectionResponse>) => (response?.error ?? response?.data)?.responseStatus;

export const usePatients = (trialCode?: string, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        return trialCode ? 
            () => new PatientGetCollectionByTrialCode({ trialCode }) : 
            undefined;
    }, [trialCode]);

    return useGet(request, { getData, getError}, configuration);
};

export default usePatients;